import React, { useEffect, useState } from "react";
import HeroCarousel from "../components/common/HeroCarousel";
import CategoryCarousel from "../components/common/CategoryCarousel";
import ShopByCategory from "../components/common/ShopByCategory";
import ScrollableProductSection from "../components/common/ScrollableProductSection";
import Lookbook from "../components/common/Lookbook";
import { heroSlides, shopByCategoryData } from "../data/products";
import bannerService from "../services/bannerService";
import productService from "../services/productService";
import { useApiEnhanced } from "../hooks/useApiEnhanced";
import "./HomePage.css";
import { useNavigate } from "react-router-dom";
import CategoryGrid from "./home/CategoryGrid";
import NewArrivals from "./home/NewArrivals";
import ShopByAge from "./home/ShopByAge";
import WinterSale from "./home/WinterSale";
import FeaturesSection from "./FeaturesSection";
import BannerRedesigned from "./BannerRedesigned";

const HomePage = ({ onProductClick }) => {
  const [banner1Data, setBanner1Data] = useState([]);
  const [banner3Data, setBanner3Data] = useState([]);

  const [banner2Data, setBanner2Data] = useState(null);
  const [newArrivals, setNewArrivals] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const navigate = useNavigate();

  // Fetch banners
  const { data: bannersResponse, loading: bannersLoading } = useApiEnhanced(
    () => bannerService.getBanners({ page: 1, limit: 50 }),
    { immediate: true }
  );

  // Fetch new arrival products
  const { data: newProductsResponse, loading: productsLoading } =
    useApiEnhanced(
      () =>
        productService.getProducts({
          page: 1,
          limit: 16,
          isNew: "true",
          status: "Active",
        }),
      { immediate: true }
    );

  // Fetch featured products for lookbook
  const { data: featuredProductsResponse } = useApiEnhanced(
    () =>
      productService.getProducts({
        page: 1,
        limit: 6,
        status: "Active",
      }),
    { immediate: true }
  );

  // Process banners when data is loaded
  useEffect(() => {
    if (bannersResponse?.success && bannersResponse?.data) {
      console.log(bannersResponse, "bannersResponse");
      const banners = bannersResponse?.data;

      // Filter banner1 and banner2
      const banner1Items = banners.filter(
        (banner) => banner.bannerIndex === "banner1"
      );
      const banner3Items = banners.filter(
        (banner) => banner.bannerIndex === "banner3"
      );
      const banner2Items = banners.filter(
        (banner) => banner.bannerIndex === "banner2"
      );

      setBanner1Data(banner1Items);
      setBanner3Data(banner3Items);
      setBanner2Data(banner2Items.length > 0 ? banner2Items[0] : null);
    }
  }, [bannersResponse]);

  // Process new products when data is loaded
  useEffect(() => {
    if (newProductsResponse?.success && newProductsResponse?.data) {
      setNewArrivals(newProductsResponse.data);
    }
  }, [newProductsResponse]);

  // Process featured products when data is loaded
  useEffect(() => {
    if (featuredProductsResponse?.success && featuredProductsResponse?.data) {
      setFeaturedProducts(featuredProductsResponse.data);
    }
  }, [featuredProductsResponse]);

  // Prepare slides for HeroCarousel (desktop)
  const getHeroSlides = () => {
    if (banner1Data.length > 0) {
      return banner1Data.map((banner) => ({
        image: banner.image?.url || "/images/desktopbanners/banner1.jpg",
        title: banner.title || "",
        subtitle: "",
        ctaText: "Shop Now",
        ctaLink: banner.url || "/products",
      }));
    }
    return heroSlides;
  };

  // Prepare mobile slides for HeroCarousel
  const getMobileSlides = () => {
    if (banner3Data.length > 0) {
      return banner3Data.map((banner) => ({
        image: banner.image?.url || "/images/mobilebanners/4mobile.jpg",
        title: banner.title || "",
        subtitle: "",
        ctaText: "Shop Now",
        ctaLink: banner.url || "/products",
      }));
    }
    // Fallback to desktop banners if no mobile banners
    return getHeroSlides();
  };

  return (
    <div className="home-page">
      {/* Fixed Video Background Section */}
      {/* <div className="video-hero-section">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="hero-video-background"
        >
          <source
            src="https://videos.pexels.com/video-files/853800/853800-hd_1920_1080_25fps.mp4"
            type="video/mp4"
          />
        </video>
        <div className="video-overlay"></div>
        <div className="video-content">
          <h1 className="video-title">Tiny Threads, Big Dreams</h1>
          <p className="video-subtitle">
            Discover comfort & style for your little ones
          </p>
          <button
            className="video-cta-button"
            onClick={() => navigate("/products")}
          >
            Explore Collection
          </button>
        </div>
      </div> */}

      {/* Scrollable Content that overlays the video */}
      <div className="scrollable-content">
        {/* Hero Carousel - show skeleton while banners load */}
        {bannersLoading ? (
          <div className="hero-skeleton">
            <div className="hero-skeleton-shimmer" />
          </div>
        ) : (
          <HeroCarousel slides={getHeroSlides()} mobileSlides={getMobileSlides()} />
        )}
        <CategoryGrid />
        {/* Shop by Category Section */}
        {/* <section className="shop-by-category-section">
          <div className="container">
            <h2 className="section-title">SHOP BY CATEGORY</h2>
            <div className="category-grid">
              <div className="category-card category-card-pink">
                <div className="category-icon">
                  <svg
                    height="100"
                    width="100"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <circle
                      fill="currentColor"
                      cx="219.869"
                      cy="183.266"
                      r="9.765"
                    ></circle>
                    <path
                      fill="currentColor"
                      d="M292.131,173.5c-5.398,0-9.772,4.375-9.772,9.766s4.374,9.765,9.772,9.765c5.391,0,9.766-4.374,9.766-9.765 S297.523,173.5,292.131,173.5z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="M358.949,157.488c-4.882-22.935-17.149-43.134-34.205-57.969c-18.627-16.2-43.02-26.032-69.647-26.032 c-26.587,0-50.94,9.798-69.554,25.958c-17.156,14.882-29.49,35.182-34.339,58.237c-7.076,0.923-13.444,4.207-18.233,8.989 c-5.725,5.733-9.29,13.712-9.29,22.46c0,8.729,3.565,16.715,9.29,22.44c5.725,5.725,13.705,9.284,22.447,9.284 c0.602,0,1.19-0.014,1.779-0.04c4.508,10.715,10.742,20.54,18.327,29.135l-1.204,0.89l101.071,136.226l11.764-8.735l-19.805-26.688 l65.394-96.662l-1.678-1.137c9.277-9.504,16.781-20.735,21.998-33.188c1.137,0.127,2.32,0.201,3.512,0.201 c8.741,0,16.714-3.559,22.439-9.284c5.726-5.725,9.298-13.711,9.298-22.44c0-8.748-3.572-16.728-9.298-22.46 C373.812,161.474,366.755,158.063,358.949,157.488z M243.385,88.897c3.839-0.488,7.746-0.756,11.712-0.756 c5.384,0,10.641,0.475,15.778,1.364c0.521,0.609,1.07,1.318,1.618,2.14c2.314,3.512,4.648,9.023,4.668,17.745 c0,6.601-1.391,15.07-5.31,25.724c-12.36-9.939-19.397-19.096-23.383-26.64c-4.334-8.227-5.117-14.581-5.124-18.26 C243.345,89.72,243.359,89.285,243.385,88.897z M234.556,90.455c0.034,4.977,1.191,12.762,6.14,22.119 c2.214,4.194,5.177,8.695,9.11,13.404c-3.933-1.585-7.866-3.063-11.572-4.628c-6.367-2.682-11.958-5.685-15.752-9.685 c-1.906-2-3.397-4.247-4.461-6.956c-0.883-2.254-1.445-4.882-1.619-7.993C222.156,94.027,228.229,91.907,234.556,90.455z M368.661,201.198c-3.123,3.103-7.344,5.01-12.086,5.01c-1.96,0-3.84-0.355-5.652-0.977l-6.943-2.448l-2.421,6.943 c-6.207,17.885-17.818,33.275-32.881,44.171c-3.946,2.856-8.114,5.411-12.494,7.604c0.307,2.007,0.455,4.034,0.455,6.094 c0,3.558-0.455,7.043-1.338,10.401c2.034-0.836,4.04-1.733,6.006-2.696L258.1,339.175l-46.438-62.592 c1.725,0.776,3.464,1.519,5.237,2.201c-1.03-3.586-1.552-7.351-1.552-11.19c0-1.772,0.114-3.545,0.347-5.27 c-4.922-2.348-9.591-5.124-13.965-8.274c-15.036-10.815-26.667-26.092-32.948-43.857l-2.267-6.421l-6.562,1.806 c-1.512,0.408-3.003,0.629-4.535,0.629c-4.736,0-8.976-1.906-12.08-5.01c-3.103-3.104-5.01-7.337-5.01-12.066 c0-4.749,1.907-8.983,5.01-12.086c3.103-3.11,7.344-5.01,12.08-5.01c0.301,0,0.736,0.034,1.351,0.074l6.809,0.528l1.016-6.736 c3.311-22.005,14.474-41.441,30.54-55.387c4.013-3.478,8.334-6.622,12.908-9.37c0.402,2.482,1.01,4.809,1.86,6.949 c1.351,3.391,3.25,6.327,5.492,8.842c3.933,4.401,8.849,7.498,13.986,10.039c7.718,3.793,16.052,6.415,23.055,9.685 c3.498,1.626,6.648,3.391,9.237,5.432c2.582,2.04,4.602,4.307,6.046,7.07c0.776,1.492,2.328,2.401,4.006,2.368 c1.679-0.04,3.178-1.023,3.88-2.555c7.605-16.461,10.334-29.41,10.34-39.583c0.013-6.936-1.291-12.554-3.137-16.969 c12.039,3.819,23.002,10.046,32.332,18.153c16.079,13.993,27.208,33.469,30.493,55.528l1.084,7.264l7.27-1.11 c0.964-0.147,1.806-0.221,2.589-0.221c4.742,0,8.962,1.9,12.086,5.01c3.103,3.103,4.99,7.337,5.01,12.086 C373.651,193.86,371.765,198.094,368.661,201.198z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="M256,235.744c-8.776,0-16.788,3.579-22.527,9.33c-5.752,5.739-9.337,13.758-9.33,22.527 c-0.006,8.768,3.578,16.782,9.33,22.526c5.739,5.753,13.751,9.331,22.527,9.324c8.769,0.006,16.782-3.572,22.527-9.324 c5.752-5.745,9.324-13.758,9.324-22.526c0-8.769-3.572-16.788-9.324-22.527C272.782,239.322,264.769,235.744,256,235.744z M270.822,273.855c-1.218,2.876-3.264,5.344-5.84,7.082c-2.575,1.733-5.625,2.736-8.982,2.736c-2.247,0-4.341-0.449-6.254-1.258 c-2.883-1.211-5.35-3.264-7.083-5.833c-1.739-2.575-2.742-5.625-2.742-8.982c0-2.248,0.455-4.341,1.258-6.261 c1.218-2.869,3.264-5.344,5.832-7.083c2.582-1.732,5.632-2.736,8.99-2.736c2.24,0,4.334,0.448,6.254,1.258 c2.876,1.217,5.344,3.27,7.084,5.839c1.739,2.568,2.735,5.625,2.742,8.983C272.079,269.842,271.624,271.935,270.822,273.855z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="M256,216.641c-21.631,0-39.182,10.488-39.182,23.437c0,3.86,1.565,7.504,4.348,10.735 c1.686-2.789,3.739-5.391,6.093-7.752c7.659-7.678,17.865-11.906,28.727-11.906c10.896,0,21.089,4.227,28.761,11.918 c2.361,2.348,4.401,4.95,6.086,7.739c2.783-3.231,4.348-6.876,4.348-10.735C295.181,227.129,277.645,216.641,256,216.641z"
                    ></path>
                  </svg>
                </div>
                <h3 className="category-name">Newborn</h3>
              </div>

              <div className="category-card category-card-yellow">
                <div className="category-icon">
                  <img
                    src="/images/babygirl.png"
                    alt="Girls"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <h3 className="category-name">Girls</h3>
              </div>

              <div className="category-card category-card-blue">
                <div className="category-icon">
                  <img
                    src="/images/babyboy.png"
                    alt="Boys"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <h3 className="category-name">Boys</h3>
              </div>
            </div>

            <div className="explore-button-container">
              <button
                className="explore-all-button"
                onClick={() => navigate("/products")}
              >
                EXPLORE ALL
              </button>
            </div>
          </div>
        </section> */}
        <NewArrivals onProductClick={onProductClick} />
        <ShopByAge />
        {/* Tiny Treasures Banner - Using Banner2 data */}
        {/* <section className="tiny-treasures-banner">
          {banner2Data ? (
            <div className="banner-full-image">
              <img
                src={banner2Data.image?.url}
                alt={banner2Data.title || "Banner"}
                className="banner-responsive-image"
                onClick={() => {
                  if (banner2Data.url) {
                    window.location.href = banner2Data.url;
                  }
                }}
              />
            </div>
          ) : (
            <div className="banner-content-wrapper">
              <div className="banner-text-section">
                <h2 className="banner-main-title">
                  TINY CLOTHES, GIANT DREAMS
                </h2>
              </div>
              <div className="banner-image-section">
                <div className="product-display">
                  <img
                    src="/images/banner2.png"
                    alt="Baby clothes and accessories"
                    className="banner-product-image"
                  />
                </div>
              </div>
              <div className="banner-cta-section">
                <button className="shop-treasures-button">
                  SHOP TINY TREASURES
                </button>
              </div>
            </div>
          )}
        </section> */}
        <BannerRedesigned
          banner2Data={banner2Data}
          mobileBanner2Data={banner3Data.length > 0 ? banner3Data[0] : null}
        />
        {/* New Arrivals - Using API data */}
        {/* {!productsLoading && newArrivals.length > 0 && (
          <ScrollableProductSection
            title="New Arrivals"
            products={newArrivals}
            onProductClick={onProductClick}
          />
        )} */}
        {productsLoading ? (
          <div className="section-loader">
            <div className="section-loader-spinner" />
            <p>Loading products...</p>
          </div>
        ) : (
          <WinterSale onProductClick={onProductClick} />
        )}
        {/* Loading state for New Arrivals */}
        {/* {productsLoading && (
          <div style={{ textAlign: "center", padding: "60px 20px" }}>
            <div
              className="spinner"
              style={{
                border: "3px solid #f3f3f3",
                borderTop: "3px solid #c77a5c",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                animation: "spin 1s linear infinite",
                margin: "0 auto 20px",
              }}
            ></div>
            <p>Loading new arrivals...</p>
          </div>
        )} */}

        {/* Lookbook Section */}
        <Lookbook
          featuredProducts={featuredProducts}
          onProductClick={onProductClick}
        />

        {/* Features Section */}
        {/* <section className="features-section-home">
          <div className="container">
            <div className="features-grid-home">
              <div className="feature-card-home feature-card-pink">
                <div className="feature-icon-home">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M1 3h15v13H1zM16 8h5v13H8z" />
                  </svg>
                </div>
                <h3 className="feature-title-home">Free Delivery</h3>
                <p className="feature-desc-home">On orders above ₹999</p>
                <div className="feature-decoration">🎁</div>
              </div>

              <div className="feature-card-home feature-card-blue">
                <div className="feature-icon-home">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    <path d="M9 22V12h6v10" />
                  </svg>
                </div>
                <h3 className="feature-title-home">Easy Exchange</h3>
                <p className="feature-desc-home">30-day return policy</p>
                <div className="feature-decoration">🔄</div>
              </div>

              <div className="feature-card-home feature-card-green">
                <div className="feature-icon-home">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <path d="M9 12l2 2 4-4" />
                  </svg>
                </div>
                <h3 className="feature-title-home">Secure Payment</h3>
                <p className="feature-desc-home">100% secure transactions</p>
                <div className="feature-decoration">🔒</div>
              </div>

              <div className="feature-card-home feature-card-purple">
                <div className="feature-icon-home">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M12 2L2 7l10 5 10-5-10-5z" />
                    <path d="M2 17l10 5 10-5M2 12l10 5 10-5" />
                  </svg>
                </div>
                <h3 className="feature-title-home">Premium Threads</h3>
                <p className="feature-desc-home">Finest quality fabrics</p>
                <div className="feature-decoration">✨</div>
              </div>
            </div>
          </div>
        </section> */}
        <FeaturesSection />
      </div>
    </div>
  );
};

export default HomePage;
